import { v4 as uuid } from 'uuid';
import EventSubscriber from './EventSubscriber';
const PageManager = () => {
  const pageEventSubscriber = EventSubscriber();
  const beforeUnload = (pageUnloader, propsParam) => {
    const props = propsParam || {};
    const {
      eventName = uuid(),
      preventPageUnload = false,
      eventProps = []
    } = props;
    const eventHandler = event => {
      if (preventPageUnload) {
        event.preventDefault();
      }
      pageUnloader(...eventProps);
    };
    pageEventSubscriber.subscribe(eventName, eventHandler);
    window.addEventListener('beforeunload', eventHandler);
    return eventName;
  };
  const unsubscribeBeforeOnload = eventName => {
    const eventHandler = pageEventSubscriber.getEvent(eventName);
    pageEventSubscriber.unsubscribe(eventName);
    window.removeEventListener('beforeunload', eventHandler);
  };
  return {
    beforeUnload,
    unsubscribeBeforeOnload
  };
};
export default PageManager;
//# sourceMappingURL=PageManager.js.map